(function ($) {
    theme.AssetsLoader.onPageLoaded(function () {
        function init(){
            class ExclusiveSelection {
                constructor(options) {
                    this.options = options;
                    this.selectedOption = this.findDefaultSelectedOption();
                }
    
                init() {
                    this.options.forEach(option => {
                        option.addEventListener('click', this.handleOptionClick.bind(this));
                    });
                }
    
                handleOptionClick(event) {
                    const clickedOption = event.target.closest('.xtool-care__item');
    
                    if (!clickedOption || event.target.id === 'xtool-care__handle--learn-more') {
                        return;
                    }
    
                    this.selectedOption = clickedOption;
                    if (clickedOption.classList.contains('xtool-care__content--selected')) {
                        this.selectedOption.classList.remove('xtool-care__content--selected');
                    } else {
                        this.selectedOption.classList.add('xtool-care__content--selected');
                    }
    
                    // if (window.isUpMobileConversion && window.innerWidth < 1025) {
                    //     this.selectedOption = clickedOption;
                    //     if (clickedOption.classList.contains('xtool-care__content--selected')) {
                    //         this.selectedOption.classList.remove('xtool-care__content--selected');
                    //     } else {
                    //         this.selectedOption.classList.add('xtool-care__content--selected');
                    //     }
                    // } else {
                    //     if (this.selectedOption) {
                    //         this.selectedOption.classList.remove('xtool-care__content--selected');
                    //     }
        
                    //     this.selectedOption = clickedOption;
                    //     this.selectedOption.classList.add('xtool-care__content--selected');
                    // }
                
                    //let isNeedCare = false;
                    
                    // if (window.isUpMobileConversion && window.innerWidth < 1025) {
                    //     isNeedCare = this.selectedOption.classList.contains('xtool-care__content--selected') ? true : false;
                    // } else {
                    //     isNeedCare = this.selectedOption.classList.contains('not-xtool-care') ? false : true;
                    // }
                   // const isNeedCare = this.selectedOption.classList.contains('not-xtool-care') ? false : true;
                   
                   let isNeedCare = this.selectedOption.classList.contains('xtool-care__content--selected') ? true : false; 
                   document.dispatchEvent(new CustomEvent('theme:care::select', {
                        detail: {
                            isNeedCare: isNeedCare
                        }
                    }));
                }
    
                findDefaultSelectedOption() {
                    return this.options.find(option => option.classList.contains('xtool-care__content--selected'));
                }
            }
    
            class Modal {
                constructor() {
                    this.modalOverlay = null;
                    this.modalElement = null;
                    this.closeButton = null;
                    this.isOpen = false;
                    this.bodyOverflowStyle = document.body.style.overflow;
    
                    this.styles = `
                    .modal-overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(0, 0, 0, 0.5);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        z-index: 9999;
                    }
                
                    .modal {
                        position: relative;
                        background-color: #fff;
                        border-radius: 16px;
                        width: 930px;
                        height: 537px;
                    }
                
                    .modal-content {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 100%;
                        z-index: 99999;
                        position: relative;
                        width: 100%;
                    }
                    .modal-content > * {
                        flex: 1;
                    }
                    .left-content {
                        overflow: hidden;
                        border-radius: 16px 0 0 16px;
                        height: 100%;
                    }
                    .left-content img {
                        max-width: fit-content;
                        height: 100%;
                    }
                    .right-content {
                        position: relative;
                        padding: 0 36px;
                        height: 100%;
                        max-width: 50%;
                    }

                    .right-content .xtool-care__sale-tag {
                        position: absolute;
                        top: 0px;
                        left: 0px;
                        background-color: var(--primary-color, #28BE44);
                        color: #fff;
                        font-size: 14px;
                        font-weight: 500;
                        padding: 4px 12px;
                        font-weight: 500;
                        line-height: 18px;
                        border-bottom-right-radius: 8px;
                        margin-bottom: 0;
                    }
                    .modal-close {
                        z-index: 100000;
                        position: absolute;
                        top: 16px;
                        right: 16px;
                        cursor: pointer;
                    }
                    .header {
                        display: flex;
                        justify-content: center;
                        align-items: flex-start;
                        margin-top: 64px;
                    }
                    .care-content {
                        flex: 1;
                        margin-left: 24px;
                        
                    }
                    .care-content h2{
                        font-family: Montserrat;
                        font-size: 24px;
                        font-weight: 600;
                        text-align: left;
                        margin-bottom: 0;
                        line-height: 28px;
                        width: 214px;
                        letter-spacing: 0;
                    }
                    .care-content .desc{
                        font-family: Montserrat;
                        font-size: 17px;
                        font-weight: 500;
                        color: #888888;
                        margin-bottom: 24px;
                        margin-top: 8px;
                    }
                    .care-content .compare-price {
                        font-size: 14px;
                        font-weight: 500;
                        line-height: 18px;
                        text-decoration: line-through;
                        color: #646864;
                    }
                    .line {
                        position: relative;
                        padding: 24px 0;
                    }
                      
                    .line::before {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 0;
                        width: 100%;
                        height: 1px;
                        background-color: var(--care-line-color);
                        transform: scaleY(0.5);
                    }
                    .price {
                        display: flex;
                        gap: 8px;
                        font-family: Montserrat;
                        font-size: 24px;
                        font-weight: 600;
                        color: #1D1D1D;
                        align-items: center;
                    }
                    .text > * {
                        font-family: Montserrat;
                        font-size: 12px;
                        font-weight: 400;
                        text-align: left;
                        margin-bottom: 16px;
                    }
                    @media (max-width: 1024px) { 
                        .modal {
                            width: 359px;
                            height: 625px;
                            border-radius: 24px;
                        }
                        .modal-content {
                            display: block;
                            overflow-y: scroll;
                            flex-direction: column;
                            -ms-overflow-style: none;  /* IE and Edge */
                            scrollbar-width: none;     /* Firefox */
                        }
                        .modal-content::-webkit-scrollbar {
                            display: none;  /* Chrome, Safari and Opera */
                        }
                        .left-content {
                            height: 200px;
                            flex: unset !important;
                            overflow: hidden;
                            border-radius: 16px 16px 0 0;
                        }
                        .left-content img {
                            height: 200px !important;
                        }
                        .right-content {
                            padding: 32px 24px 40px;
                            max-width: 100%;
                            height: fit-content;
                        }
                        .img-wrapper img {
                            width: 80px;
                            height: 80px;
                        }
                        .care-content {
                            margin-left: 16px;
                        }
                        .care-content h2 {
                            font-size: 17px;
                            line-height: 20px;
                        }
                        .care-content .desc{
                            font-size: 14px;
                            margin-bottom: 16px;
                        }
                        .price {
                            font-size: 17px;
                            margin-bottom: 0;
                        }
                        .modal-close {
                            right: 16px;
                            top: 16px;
                        }
                        .header {
                            margin-top: 0;
                        }
                        .text > div:last-child {
                            margin-bottom: 0;
                        }
                        .right-content .xtool-care__sale-tag {
                            position: relative;
                            display: inline-block;
                            font-size: 11px;
                            line-height: 16px;
                            padding: 1px 12px;
                            border-radius: 9px;
                            margin-top: 8px;
                        }
                    }
                    `;
                }
    
                /**
                 * Creates a modal element with the given content.
                 *
                 * @param {Object} content - The content of the modal element.
                 * @param {string} content.desc - The description of the modal.
                 * @param {string} content.price - The price of the modal.
                 * @param {Array<string>} content.text - The text items of the modal.
                 * @return {HTMLElement} The created modal element.
                 */
                createModalElement(content = {}) {
                    const { desc, price, comparePrice, text, imgUrlList = [] } = content;
                    const [pcImageUrl, mobileImageUrl] = imgUrlList;
                    const styleElement = document.createElement('style');
                    const saleTagText = window.__care__saleTagText;
                    styleElement.textContent = this.styles;
    
                    const renderTextItem = item => {
                        const div = document.createElement('div');
                        div.textContent = item;
                        return div;
                    }
    
                    const modalOverlay = document.createElement('div');
                    modalOverlay.classList.add('modal-overlay');
                    modalOverlay.classList.add('mk-manual-dialog-by-body');
                    modalOverlay.innerHTML = `
                    <div class="modal">
                        <span class="modal-close">
                            <img src="https://cdn.shopify.com/s/files/1/0467/7985/9095/files/close-circle-filled.svg?v=1716805338" width="32" height="32">
                        </span>
                        <div class="modal-content">
                            <div class="left-content">
                                <picture class="lozad">
                                    <source media="(max-width: 950px)" srcset="${mobileImageUrl}" />
                                    <img src="${pcImageUrl}" alt="pc image"/>
                                </picture>
                            </div>
                            <div class="right-content">
                                <div class="header">
                                    <div class="img-wrapper">
                                        <img src="https://cdn.shopify.com/s/files/1/0467/7985/9095/files/xtool-care.png?v=1695291646" width="120" height="120">
                                    </div>
                                    <div class="care-content">
                                        <h2>xToolCare</h2>
                                        <p class="desc">${desc}</p>
                                        <p class="price">
                                            <span>${price}</span>
                                            ${comparePrice ? `<span class="compare-price">${comparePrice}</span>` : ''}
                                        </p>
                                        ${saleTagText ? `<p class="xtool-care__sale-tag">${saleTagText}</p>` : ''}
                                    </div>
                                </div>
                                <div class="line"></div>
                                <div class="text"></div>
                            </div>
                        </div>
                    </div>
                    `;
                    const textContainer = modalOverlay.querySelector('.text');
                    text?.forEach(item => {
                        const renderedItem = renderTextItem(item);
                        textContainer.appendChild(renderedItem);
                    });
    
                    this.modalOverlay = modalOverlay;
                    this.modalElement = modalOverlay.querySelector('.modal');
                    this.closeButton = modalOverlay.querySelector('.modal-close');
                    document.head.appendChild(styleElement);
                    return modalOverlay;
                }
    
                open(content) {
                    if (this.isOpen) {
                        return;
                    }
                    const modalOverlay = this.createModalElement(content);
                    document.body.appendChild(modalOverlay);
                    this.isOpen = true;
                    this.addEventListeners();
                    if(theme.current.is_mobile) {
                        this.stopScroll();
                    } else {
                        document.body.style.overflow = 'hidden';
                    }
                }
    
                close() {
                    if (!this.isOpen) {
                        return;
                    }
                    this.modalOverlay.remove();
                    this.isOpen = false;
                    this.removeEventListeners();
                    if(theme.current.is_mobile) {
                        this.recoverScroll();
                    } else {
                        document.body.style.overflow = this.bodyOverflowStyle;
                    }
                }
    
                addEventListeners() {
                    this.closeButton.addEventListener('click', this.close.bind(this));
                    //this.modalOverlay.addEventListener('click', this.handleOverlayClick.bind(this));
                    document.addEventListener('keydown', this.handleKeyDown.bind(this));
                }
    
                removeEventListeners() {
                    this.closeButton.removeEventListener('click', this.close.bind(this));
                    //this.modalOverlay.removeEventListener('click', this.handleOverlayClick.bind(this));
                    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
                }
    
                handleOverlayClick(event) {
                    if (event.target === this.modalOverlay) {
                        this.close();
                    }
                }
    
                handleKeyDown(event) {
                    if (event.key === 'Escape') {
                        this.close();
                    }
                }
    
                // 展示弹窗时，阻止背景滚动
                stopScroll () {
                    let top = document.body.scrollTop || document.documentElement.scrollTop;
                    document.body.style.position = 'fixed';
                    document.body.style.top = `${-1 * top}px`;
                    // document.body.style.width = `100%`;
                }
                // 隐藏弹窗时，恢复背景的滚动
                recoverScroll () {
                    let top = -parseInt(document.body.style.top);
                    document.body.style.position = 'static';
                    document.body.style.top = 0;
                    window.scrollTo(0, top);
                }
    
            }
    
            class DetainmentModal {
                constructor() {
                    this.modalOverlay = null;
                    this.modalElement = null;
                    this.closeButton = null;
                    this.cancelButton = null;
                    this.confirmButton = null;
                    this.isOpen = false;
                    this.bodyOverflowStyle = document.body.style.overflow;
                    this.styles = `
                    .modal-overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(0, 0, 0, 0.5);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        z-index: 9999;
                    }
                
                    .modal-detainment {
                        position: relative;
                        background-color: #fff;
                        border-radius: 16px;
                        width: 980px;
                        height: 630px;
                    }
                
                    .modal-detainment .modal-content {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 100%;
                        z-index: 99999;
                        position: relative;
                        width: 100%;
                    }
                    .modal-content > * {
                        flex: 1;
                    }
                    .modal-detainment .left-content {
                        overflow: hidden;
                        border-radius: 16px 0 0 16px;
                        height: 100%;
                        width: 460px;
                        flex: auto !important;
                    }
                    .modal-detainment .left-content img {
                        height: 100%;
                    }
                    .modal-detainment .right-content {
                        position: relative;
                        padding: 64px 32px 40px;
                        height: 100%;
                    }
                    .modal-detainment .xtool-care__sale-tag {
                        position: absolute;
                        top: 0px;
                        left: 0px;
                        background-color: var(--primary-color, #28BE44);
                        color: #fff;
                        font-size: 14px;
                        font-weight: 500;
                        padding: 4px 12px;
                        font-weight: 500;
                        line-height: 18px;
                        border-bottom-right-radius: 8px;
                    }
                    .modal-detainment .modal-close {
                        position: absolute;
                        top: 16px;
                        right: 16px;
                        cursor: pointer;
                        z-index: 100000;
                    }
                    .modal-detainment .header {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-top: 0px;
                    }
                    .modal-detainment .img-wrapper {
                        flex-shrink: 0;
                        flex-basis: initial;
                    }
                    .modal-detainment .img-wrapper img{
                        width: 80px;
                        height: 80px;
                    }
                    .modal-detainment .care-content {
                        flex: 1;
                        margin-left: 16px;
                    }
                    .modal-detainment .care-content h2{
                        font-family: Montserrat;
                        font-size: 24px;
                        font-weight: 600;
                        text-align: left;
                        margin-bottom: 0;
                        width: 213px;
                        letter-spacing: 0;
                        line-height: 28px;
                    }
                    .care-content .desc{
                        font-family: Montserrat;
                        font-size: 17px;
                        font-weight: 500;
                        color: #888888;
                        margin-bottom: 0;
                        margin-top: 8px;
                    }
                    .modal-detainment .price {
                        font-family: Montserrat;
                        font-size: 24px;
                        font-weight: 600;
                        color: #1D1D1D;
                        flex: none;
                    }
                    .modal-detainment .compare-price {
                        font-size: 14px;
                        font-weight: 500;
                        line-height: 18px;
                        text-decoration: line-through;
                        color: #646864;
                    }
                    .text > * {
                        font-family: Montserrat;
                        font-size: 12px;
                        font-weight: 400;
                        text-align: left;
                        margin-bottom: 8px;
                        color: #747474;
                    }
                    .modal-detainment .care-table {
                        margin-top: 32px;
                        margin-bottom: 32px;
                    }
                    .modal-detainment .care-table, .modal-detainment .care-table img{
                        height: 193px;
                    }
                    .modal-detainment .care-btn-wrapper {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        gap: 16px;
                        margin: 16px 0;
                    }
                    .modal-detainment .care-btn--cancel {
                        width: 214px;
                        height: 56px;
                        padding: 20px 24px;
                        border-radius: 40px;
                        background: #F8F9FC;
                        text-align: center;
                        font-family: Montserrat;
                        font-size: 14px;
                        font-weight: 600;
                        cursor: pointer;
                    }
                    .modal-detainment .care-btn--confirm {
                        width: 214px;
                        height: 56px;
                        line-height: 56px;
                        border-radius: 40px;
                        background: #28BE44;
                        text-align: center;
                        color: #ffffff;
                        font-family: Montserrat;
                        font-size: 14px;
                        font-weight: 600;
                        cursor: pointer;
                    }
                    .modal-detainment .price-pc {
                        display: flex;
                        gap: 10px;
                        flex-direction: column;
                        text-align: right;
                        line-height: 1;
                    }
                    .modal-detainment .price-mobile {
                        display: none;
                    }
                    @media (max-width: 1024px) { 
                        .modal-detainment {
                            width: 359px;
                            height: 625px;
                            border-radius: 24px;
                            overflow: hidden;
                        }
                        .modal-detainment .modal-content {
                            overflow-y: scroll;
                            flex-direction: column;
                        }
                        .modal-detainment .left-content {
                            height: 200px;
                            width: 100%;
                            display: none;
                            overflow: hidden;
                            border-radius: 24px 24px 0 0;
                        }
                        .modal-detainment .left-content img {
                            height: 200px !important;
                        }
                        .modal-detainment .right-content {
                            padding: 32px 24px 40px;
                            max-width: 100%;
                            position: absolute;
                        }
                        .modal-detainment .img-wrapper img {
                            width: 80px;
                            height: 80px;
                        }
                        .modal-detainment .care-content {
                            margin-left: 16px;
                        }
                        .modal-detainment .care-btn-wrapper { 
                            gap: 0;
                        }
                        .modal-detainment .care-content h2 {
                            font-size: 17px;
                            line-height: 20px;
                            width: 159px;
                        }
                        .modal-detainment .care-content .desc{
                            font-size: 14px;
                            margin-bottom: 16px;
                        }
                        .price {
                            font-size: 17px;
                            margin-bottom: 0;
                        }
                        .modal-close {
                            position: fixed;
                            right: 16px;
                        }
                        .care-btn--cancel {
                            width: 158px;
                            border-radius: 28px;
                            padding: 12px 29px;
                        }
                        .care-btn--confirm {
                            width: 158px;
                            border-radius: 28px;
                            padding: 12px 29px;
                        }
                        .modal-detainment .care-table, .modal-detainment .care-table img{
                            text-align: center;
                        }
                        .modal-detainment .care-btn--confirm, .modal-detainment .care-btn--cancel { 
                            padding: 12px 24px;
                        }
                        .modal-detainment .care-btn--confirm {
                            line-height: normal;
                            margin-left: 16px;
                        }
                        .modal-detainment .price-pc {
                            display: none;
                        }
                        .modal-detainment .price-mobile {
                            display: flex;
                            gap: 8px;
                            margin-top: 16px;
                            font-size: 17px;
                        }
                        .modal-detainment .care-table {
                            margin-top: 48px;
                            margin-bottom: 64px;
                        }
                        .modal-detainment .text > div:last-child {
                            margin-bottom: 0;
                        }
                        .modal-detainment .xtool-care__sale-tag {
                            position: relative;
                            display: inline-block;
                            font-size: 11px;
                            line-height: 16px;
                            padding: 1px 12px;
                            border-radius: 9px;
                            margin-top: 8px;
                        }
                    }
                    `;
                }
    
                /**
                 * Creates a modal element with the given content.
                 *
                 * @param {Object} content - The content of the modal element.
                 * @param {string} content.desc - The description of the modal.
                 * @param {string} content.price - The price of the modal.
                 * @param {Array<string>} content.text - The text items of the modal.
                 * @return {HTMLElement} The created modal element.
                 */
                createModalElement(content = {}) {
                    const { desc, price, comparePrice, text, imgUrl = "", tableImgUrlList = [] } = content;
                    const [pcCareTableImageUrl, mobileCareTableImageUrl] = tableImgUrlList;
                    const styleElement = document.createElement('style');
                    styleElement.textContent = this.styles;
                    const saleTagText = window.__care__saleTagText;

                    const renderTextItem = item => {
                        const div = document.createElement('div');
                        div.textContent = item;
                        return div;
                    }
    
                    const modalOverlay = document.createElement('div');
                    modalOverlay.classList.add('modal-overlay');
                    modalOverlay.classList.add('care-modal-overlay')
                    modalOverlay.innerHTML = `
                    <div class="modal-detainment">
                        <span class="modal-close">
                            <img src="https://cdn.shopify.com/s/files/1/0467/7985/9095/files/close-circle-filled.svg?v=1716805338" width="32" height="32">
                        </span>
                        <div class="modal-content">
                            <div class="left-content">
                                <picture class="lozad">
                                    <img src="${imgUrl}" alt="pc image"/>
                                </picture>
                            </div>
                            <div class="right-content">
                                <div class="header">
                                    <div class="img-wrapper">
                                        <img src="https://cdn.shopify.com/s/files/1/0467/7985/9095/files/xtool-care.png?v=1695291646" width="120" height="120">
                                    </div>
                                    <div class="care-content">
                                        <h2>xToolCare</h2>
                                        <p class="desc">${desc}</p>
                                        <div class="price price-mobile">
                                            <span>${price}</span>
                                            ${comparePrice ? `<span class="compare-price">${comparePrice}</span>` : ''}
                                        </div>
                                        ${saleTagText ? `<span class="xtool-care__sale-tag">${saleTagText}</span>` : ''}
                                    </div>
                                    <div class="price price-pc">
                                        ${price}
                                        ${comparePrice ? `<span class="compare-price">${comparePrice}</span>` : ''}
                                    </div>
                                </div>
                                <div class="care-table">
                                    <picture class="lozad">
                                        <source media="(max-width: 950px)" srcset="${mobileCareTableImageUrl}" />
                                        <img src="${pcCareTableImageUrl}" alt="pc image"/>
                                    </picture>
                                </div>
                                <div class="care-btn-wrapper">
                                    <div class="care-btn--cancel">${__Xtool_Utils.t('products.care_info.maybe')}</div>
                                    <div class="care-btn--confirm">${__Xtool_Utils.t('products.care_info.extra')}</div>
                                </div>
                                <div class="text"></div>
                            </div>
                        </div>
                    </div>
                    `;
                    const textContainer = modalOverlay.querySelector('.text');
                    text?.forEach(item => {
                        const renderedItem = renderTextItem(item);
                        textContainer.appendChild(renderedItem);
                    });
    
                    this.modalOverlay = modalOverlay;
                    this.modalElement = modalOverlay.querySelector('.modal');
                    this.closeButton = modalOverlay.querySelector('.modal-close');
                    this.cancelButton = modalOverlay.querySelector('.care-btn--cancel');
                    this.confirmButton = modalOverlay.querySelector('.care-btn--confirm');
                    document.head.appendChild(styleElement);
                    return modalOverlay;
                }
    
                open(content) {
                    if (this.isOpen) {
                        return;
                    }
                    const modalOverlay = this.createModalElement(content);
                    document.body.appendChild(modalOverlay);
                    this.isOpen = true;
                    this.addEventListeners();
                    if(theme.current.is_mobile) {
                        this.stopScroll();
                    } else {
                        document.body.style.overflow = 'hidden';
                    }
                }
    
                close() {
                    if (!this.isOpen) {
                        return;
                    }
                    this.modalOverlay.remove();
                    this.isOpen = false;
                    this.removeEventListeners();
                    this.handleSetModalStatus();
                    theme.Cart.showPopup();
                    if(theme.current.is_mobile) {
                        this.recoverScroll();
                    } else {
                        document.body.style.overflow = this.bodyOverflowStyle;
                    }
                }
    
                addEventListeners() {
                    this.closeButton.addEventListener('click', this.close.bind(this));
                    //this.modalOverlay.addEventListener('click', this.handleOverlayClick.bind(this));
                    this.cancelButton.addEventListener('click', this.handleCancelButtonClick.bind(this));
                    this.confirmButton.addEventListener('click', this.handleConfirmButtonClick.bind(this));
                    document.addEventListener('keydown', this.handleKeyDown.bind(this));
                }
    
                removeEventListeners() {
                    this.closeButton.removeEventListener('click', this.close.bind(this));
                    //this.modalOverlay.removeEventListener('click', this.handleOverlayClick.bind(this));
                    this.cancelButton.removeEventListener('click', this.handleCancelButtonClick.bind(this));
                    this.confirmButton.removeEventListener('click', this.handleConfirmButtonClick.bind(this));
                    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
                }
    
                handleCancelButtonClick() {
                    this.close();
                    this.handleSetModalStatus();
                    window.__care__care_track_data.modal_status = this.checkModalStatus();
                    theme.Cart.showPopup();
                }
    
                handleConfirmButtonClick() {
                    this.close();
                    const careVariantId = $('input[name="care_variant_id"]').val();
                    const quantity = $('input[name="quantity"]').val();
    
                    theme.Cart.addItems([{ id: careVariantId, quantity }], 'winback');
                    // 埋点数据构建
                    window.__care__care_track_data = Object.assign({}, window.__care__care_track_data, { winback: true, source: 'winback' });
                }
                handleOverlayClick(event) {
                    if (event.target === this.modalOverlay) {
                        this.close();
                    }
                }
    
                handleKeyDown(event) {
                    if (event.key === 'Escape') {
                        this.close();
                    }
                }
    
                handleSetModalStatus() {
                    sessionStorage.setItem(`modal_status_${getCurrentProductVariantsInfo().id}`, 'closed');
                }
    
                checkModalStatus() { // 可以谈挽留弹窗
                    if(!getCurrentProductCareInfo()) {
                        return false;
                    }
                    const modalStatus = sessionStorage.getItem(`modal_status_${getCurrentProductVariantsInfo().id}`);
                    return modalStatus === null || modalStatus !== 'closed';
                }
                // 展示弹窗时，阻止背景滚动
                stopScroll () {
                    let top = document.body.scrollTop || document.documentElement.scrollTop;
                    document.body.style.position = 'fixed';
                    document.body.style.top = `${-1 * top}px`;
                    // document.body.style.width = `100%`;
                }
                // 隐藏弹窗时，恢复背景的滚动
                recoverScroll () {
                    let top = -parseInt(document.body.style.top);
                    document.body.style.position = 'static';
                    document.body.style.top = 0;
                    window.scrollTo(0, top);
                }
    
            }
            class HandlePrice {
                constructor(careObejct = {}) {
                    this.careObejct = careObejct;
                    this.careInfo = null;
                    this.isInitialized = false;
                    this.initialize();
                }
                
                async initialize() {
                    // 先获取价格信息
                    await this.getCareInfo(this.careObejct);
                    // 再设置 careInfo
                    this.careInfo = this.getfirstCareInfo();
                    window.careObejct = this.careObejct;
                    // 设置上报数据
                    window.__care__care_track_data = { // 上报数据中
                        sku: window.__care__selected_or_first_available_variant_metafields.sku,
                        source: 'machine_listing_card',
                        ...this.careInfo
                    };
                    this.isInitialized = true;
                }
    
                init() {
                    if (!this.careInfo) { // 没有配置care信息
                        $('#xtool-care__wrapper').hide();
                    } else {
                        this.setCareInfo();
                        $('#xtool-care__wrapper').show();
                    }
                    this.watchVariantSwitch();
                }
    
                watchVariantSwitch() {
                    /**
                    **监听变体切换重新计算care价格
                    */
                    document.addEventListener('theme:product::switchVariant', (event) => {
                        const { detail: { data, $product, $clone_product, _updatePrice } } = event;
                        const { json, update_variant } = data;
                        
                        const { metafields: { product = {} } } = update_variant;
                        const { product_variant_care } = product;
                        const careInfo = this.careObejct[product_variant_care?.sku];
                        this.updateCareVariantInput({ $product, careInfo });
                        this.updateCareLabel(careInfo);
                        window.__care__care_track_data = { // 上报数据中
                            sku: product_variant_care?.sku,
                            source: 'machine_listing_card',
                            ...careInfo
                        };
                        document.dispatchEvent(new CustomEvent('theme:care::update', {
                            detail: {
                                data: data,
                                careInfo: careInfo,
                                update_variant: update_variant,
                                $product: $product,
                                $clone_product: $clone_product,
                                _updatePrice: _updatePrice
                            }
                        }));
                        this.careInfo = careInfo;
                        if (this.careInfo) this.setCareInfo();
                        //console.log(careInfo, "careInfo");        
                    });
                }
    
                setCareInfo() {
                    $('.xtool-care__name').text(`${__Xtool_Utils.t('products.care_info.for')} ${this.careInfo.machine_type}`);
                    $('.xtool-care__name').attr('data-machine-type', this.careInfo.machine_type);
                    $('.xtool-care__price').text(this.formatCarePrice(this.careInfo.price));
                    if (this.careInfo.compare_price && this.careInfo.compare_price != this.careInfo.price) {
                        $('.xtool-care__compare-price').text(this.formatCarePrice(this.careInfo.compare_price)).show();
                    } else {
                        $('.xtool-care__compare-price').hide();
                    }
                    this.updateCareLabel(this.careInfo);
                }
    
                getfirstCareInfo() {
                    if (window.__care__selected_or_first_available_variant_metafields) {
                        return this.careObejct[window.__care__selected_or_first_available_variant_metafields.sku];
                    }
                }
                // 更新care变体id
                updateCareVariantInput({ $product, careInfo }) {
                    const $input = $product.find('[data-js-product-care-variant-input]');
                    $input.attr('value', careInfo?.variant_id || '');
                }
    
                formatCarePrice(price) {
                    // return Shopify.formatMoneyMarket(price, theme.moneyFormat);
                    if (window.Shopify.currency) {
                        const hasRate = Shopify.currency.rate > 1;
                        const cMoney = hasRate ? Math.ceil(Shopify.currency.rate * price) * 100 : price * 100;
                        return Shopify?.formatMoneyMarket(cMoney, theme.moneyFormat);
                    }
                }

                async updateCareLabel(careInfo) {
                    const careLabel = $('.xtool-care__gift-label');
                    const id = careInfo?.variant_id;
                    const discountAmount = careInfo?.compare_price - careInfo?.price;
                    const careLabelMap = await getProductVariantsLabels([id], 'recommend_care');
                    const careLabelMapInfo = careLabelMap.variantInfoMap.get(id);
                    careLabel.html(this.renderVariantLabel(careLabelMapInfo, discountAmount*100));
                }

                renderVariantLabel(variantInfo, discountAmount) {
                    let htmlString = variantInfo?.html || '';
                    if (discountAmount) {
                        htmlString = htmlString.replace(/{{money}}/g, Shopify.formatMoneyMarket(discountAmount));
                    } else {
                        // 没有折扣时，隐藏 {{money}} 最近的一个html标签
                        htmlString = htmlString.replace(/<[^>]*>([^<]*{{money}}[^<]*)<\/[^>]*>/g, '');
                    }
                    if (htmlString) {
                        return htmlString;
                    }
                    return '';
                }
                async getCareInfo(careInfo) {
                    if (!careInfo) {
                        return '';
                    }
                    
                    // 使用 Promise.all 处理所有异步请求
                    const promises = Object.keys(careInfo).map(async (key) => {
                        try {
                            if (!careInfo[key].handle) {
                                return;
                            }
                            const response = await fetch(`/products/${careInfo[key].handle}.js`);
                            const product = await response.json();
                            const variants = product.variants;
                            const variant = variants.find(variant => variant.id === careInfo[key].variant_id);
                            
                            if (variant) {
                                variant.price && (careInfo[key].price = (variant.price / 100));
                                variant.compare_at_price && (careInfo[key].compare_price = (variant.compare_at_price / 100));
                            }
                        } catch (error) {
                            console.error(`Failed to fetch product data for ${careInfo[key].handle}:`, error);
                        }
                    });
                    
                    // 等待所有请求完成
                    await Promise.all(promises);
                }
            }
    
            $(document).ready(async function () {
                const options = Array.from(document.querySelectorAll('.xtool-care__item'));
                const exclusiveSelection = new ExclusiveSelection(options);
                const modal = new Modal();
                const handlePrice = new HandlePrice(window.careObejct);
    
                // 先初始化价格信息，再调用 init
                await handlePrice.initialize();
                handlePrice.init();
                exclusiveSelection.init();
                /***
                *learn more 按钮。。。。
                ***/
                $('#xtool-care__handle--learn-more').on('click', function () {
                    const desc = $('.xtool-care__name').attr('data-machine-type');
                    const price = `${$('.xtool-care__price').text()}`;
                    const comparePrice = `${$('.xtool-care__compare-price').text()}`;
                    const content = {
                        desc: `${__Xtool_Utils.t('products.care_info.for_tool')} xTool ${desc}`,
                        price: price,
                        comparePrice: comparePrice,
                        text: window.__care__modalTextList,
                        imgUrlList: window.__care__modalImgUrl
                    };
                    modal.open(content);
                })
                /***
                *监听变体间care差异变化做一些操作。。。。
                ***/
                document.addEventListener('theme:care::update', (event) => {
                    const { detail: { careInfo, update_variant, data, $product, $clone_product, _updatePrice } } = event;
                    
                    if (!careInfo) { // 没有配置care信息
                        $('#xtool-care__wrapper').hide();
                    } else {
                        // 调用更新价格的方法
                        if ($('.xtool-care__content').hasClass('xtool-care__content--selected')) {
                            selectedCareUpdatePrice({ careInfo, data, $product, $clone_product, _updatePrice });
                            //updateCareVariantInput({ $product, careInfo });
                           
                        }
                         $('#xtool-care__wrapper').show();
                    }
                });
    
                /**
                 * 同意选择care
                 */
                document.addEventListener('theme:care::select', (event) => {
                    const { detail: { isNeedCare } } = event;
                    if (isNeedCare) { // 调用更新价格的方法
                        afterSelectedCareUpdatePrice();
                    } else {
                        afterSelectedCareUpdatePrice({ price: 0 });
                    }
                });
    
                /**
                 * 切换变体的时候更新价格
                 * 也可以使用theme.ProductOptions._updatePrice ,构造参数即可。
                 * */ 
                function selectedCareUpdatePrice(params = {}) {
                    const { careInfo, data, $product, $clone_product, _updatePrice } = params;
                    window.__care_price = careInfo.price;
                    _updatePrice($product, $clone_product, data, careInfo);
                }
    
                /**
                 * 修改addItem方法更好
                 */
                // function addCareToCart() {
                //     if (theme && theme.Cart) {
                //         const value = $('input[name="care_variant_id"]').val();
                //         const quantity = $('input[name="quantity"]').val();
                //         theme.Cart.addItem({ quantity: quantity, id: value }).then(() => {
                //             Promise.resolve(theme.Cart.updateCart()); // 更新购物车
                //         });
    
                //     }
                // }
    
                function GetQueryString(name) {
                    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
                    var r = window.location.search.substr(1).match(reg);
                    if (r != null) return encodeURIComponent(r[2]); return null;
                }
    
                /**
                * 获取当前变体信息
                */
                function getCurrentProductVariantsInfo() {
                    const id = window.__care__selected_or_first_available_variant_id;
                    const current_product_variants_id = GetQueryString('variant') || id;
                    const current_product_variants_info = window.__care__product_info.find(function (element) {
                        return element.id == current_product_variants_id && element;
                    });
                    if(current_product_variants_info) {
                        return current_product_variants_info;
                    }else {
                        return window.__care__product_info.find(function (element) {
                            return element.id == id && element;
                        });
                    }
                    
                }
    
                /**
                * 获取当前变体信息
                */
                function getCurrentProductCareInfo() {
                    return getCurrentCareInfo();
                }
                /**
                * 之前这里是给变体绑定的metafields能直接监听变体切换获取，
                * 但是如果变体不切换，切换是否加购care，则需要需要通过当前变体去查找对应的care sku
                * 解决方法有：
                * 1.通过graphql去查询变体的metafields，得到变体的关联care信息。
                * 2.{% for variant in product.variants %}
                    {% assign variantMetafields = variant.metafields.product %}
                        {% comment %} 这里你可以使用 variantMetafields 来访问特定Variant的Metafields {% endcomment %}
                            {{ variantMetafields.product_variant_care }}
                    {% endfor %} 
                *先存储在js对象中，再直接读取即可。
                * 最后，再去care映射表获取care价格 => 更新价格
                */
                function afterSelectedCareUpdatePrice(currentCareInfo = getCurrentCareInfo()) {
                    const $product = $('#product-page-main');
                    const $cloneId = $product.attr('data-js-product-clone-id');
                    const $cloneProduct = $('[data-js-product-clone="' + $cloneId + '"]');
                    const json = $product.attr('data-json-product') && JSON.parse($product.attr('data-json-product'));
                    const updatePriceNeedData = {
                        update_variant: getCurrentProductVariantsInfo(),
                        json: json || window.__care__dataJsonProduct,
                        has_unselected_options: false
                    }
                    window.__care_price = currentCareInfo.price;
                    theme.ProductOptions._updatePrice($product, $cloneProduct, updatePriceNeedData, currentCareInfo, window.__fbt_price);
                }
    
                function getCurrentCareInfo() {
                    const { id } = getCurrentProductVariantsInfo();
                    const { sku } = window.__care__productVariantMatchCare[id];
                    const info = window.careObejct[sku];
                    return info;
                }
                window.getCurrentCareInfo = getCurrentCareInfo;
                const detainmentModal = new DetainmentModal();
                
                /***
                **** ======= 挽留弹窗 =======
                ***/
                window.detainmentModal = detainmentModal;
                function openDetainmentDialog() {
                    const desc = $('.xtool-care__name').attr('data-machine-type');
                    const price = `${$('.xtool-care__price').text()}`;
                    const comparePrice = `${$('.xtool-care__compare-price').text()}`;
                    const content = {
                        desc: `${__Xtool_Utils.t('products.care_info.for_tool')} xTool ${desc}`,
                        price: price,
                        comparePrice: comparePrice,
                        text: window.__care__detainmentmodalTextList,
                        imgUrl: window.__care__detainmentModalImgUrl,
                        tableImgUrlList: window.__care__detainmentModalTableImgUrl
                    };
                    if(detainmentModal.checkModalStatus()) {
                        detainmentModal.open(content);
                    }
                }
                window.openDetainmentDialog = openDetainmentDialog;
                window.getCurrentProductVariantsInfo = getCurrentProductVariantsInfo;
                window.getCurrentProductCareInfo = getCurrentProductCareInfo;
                
            });
        }
        if(window.theme){
            init()
        }else{
            document.addEventListener('theme:js::loaded', function () {
                init()
            });
        }
        
    });
})(jQueryTheme);

